import React from 'react'
import AddVoucherHeadline from '../../../components/AddVoucher/AddVoucherHeadline'

const AddVoucher = () => {
  return (
    <div>
        <AddVoucherHeadline></AddVoucherHeadline>
    </div>
  )
}

export default AddVoucher